import { render, staticRenderFns } from "./CommonRouterSection.vue?vue&type=template&id=4c33f8ef&"
import script from "./CommonRouterSection.vue?vue&type=script&lang=js&"
export * from "./CommonRouterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports